/**
 * @desc Extract date,month from string
 * vd: "04/01/2019 1:34 pm" => [ '04', '01', '2019', '1', '34' ]
 */
export function extractDate(
    date: string
): { date: number; month: number; year: number } {
    const regex = /\d+/g;
    const result = date.match(regex);
    return {
        date: Number(result != null ? result[0] : ''),
        month: Number(result != null ? result[1] : ''),
        year: Number(result != null ? result[2] : '')
    };
}
